<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />
    <b-container fluid>
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span :class="icono"></span>
          <span>Reporte</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>Vtas_portal_comer</div>
        </b-col>
      </b-row>
      <b-row>
         <b-tabs class="w-100" content-class="mt-3" justified>
          <b-tab title=" RENOVACION AUTOMATICA PORTAL COMERCIAL" v-if="$localStorageService.can('Rep_01_renov_portal_comer')">
                 <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(generar)">
              <b-row>
        <b-col class="subtitulos ml-2">
        RENOVACION AUTOMATICA PORTAL COMERCIAL
        </b-col>
      </b-row>
          <b-row>
            <b-col>
              <b-row>
                <b-col cols="4">
                  <validation-provider name="fcInicioVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de inicio:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha inicio"
                                        :max="new Date()"
                                        @input="fechaMaxima($event)"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>

                <b-col cols="4">
                  <validation-provider name="fcFinVal" :rules="{ required: true }" v-slot="validationContext">
                    <label>Fecha de fin:<validacion/></label>
                    <b-input-group size="sm" class="mb-2">
                      <b-form-datepicker placeholder="Fecha fin"
                                          v-model="filtro.fechaFin"
                                         :max="filtro.fechaInicio.addDays(diasMaximoMes) > new Date() ? new Date(): filtro.fechaInicio.addDays(diasMaximoMes)"
                                         :min="filtro.fechaInicio"
                      ></b-form-datepicker>
                    </b-input-group>
                    <validacion :texto="validationContext.errors[0] ? validationContext.errors[0] : ' '"/>
                  </validation-provider>
                </b-col>
                <b-col class="text-right col-2 mt-4">
                  <b-button
                      variant="outline-primary"
                      :disabled="loader"
                      @click="obtenerDatos()"
                  >
                    <span v-if="!loader">Buscar</span>
                    <span v-else>
                  <b-spinner small></b-spinner>
                  Buscando...
                </span>
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
        <b-col cols="12">
        <download-excel
            v-if="datosTabla.length > 0 && $localStorageService.can('Rep_renov_portal_comer_excel')"
            class="btn btn-primary"
            :data="datosTabla"
            :fields="fieldsExcel"
            worksheet="GestionVentas"
            name="Reporte de renovacion automatica.xls"
        >
          Generar Excel
          <em class="fa fa-file-excel-o"></em>
        </download-excel>
      </b-col>
      <b-row>
        <b-col cols="12">
          <b-table
            thead-tr-class="columnas"
              :items="datosTabla"
              :fields="fields"
              :per-page="$registrosPorPaginaTabla"
              :current-page="paginaActual"
              responsive
              class="parrafos"
          >
          <template v-slot:cell(montoPagado)="row">
              {{ row.item.montoPagado | monedaEntero }}
          </template>
          <template v-slot:cell(montoMenosComisiones)="row">
              {{ row.item.montoMenosComisiones | monedaEntero }}
          </template>
           <template v-slot:cell(montoMenosIVA)="row">
              $ {{ row.item.montoMenosIVA | numeroDosDecimales }}
          </template>
          </b-table>
         <div align="center" v-if="loader">
            <b-spinner variant="primary" label="Spinning"></b-spinner>
          </div>
          <b-col v-if="!loader">
            <b-alert v-if="datosTabla!==undefined && datosTabla.length === 0" variant="warning" show>No hay datos
            </b-alert>
          </b-col>
          <b-col v-if="!loader">
            <b-pagination
                v-if="datosTabla !== undefined && datosTabla.length > 10"
                align="center"
                v-model="paginaActual"
                :total-rows="datosTabla.length"
                :per-page="$registrosPorPaginaTabla"
                aria-controls="tabla"
            ></b-pagination>
          </b-col>
        </b-col>
      </b-row>
           </b-tab>
            <b-tab title="TRANSACCIONES MULTIVA" v-if="$localStorageService.can('Rep_01_trans_multiva')">
            <div>
                 <adminTransaccionesPortalComercial></adminTransaccionesPortalComercial>
            </div>
          </b-tab>
          <b-tab title="BITACORA LOGIN PORTAL COMERCIAL" v-if="$localStorageService.can('Rep_01_bitac_login_portal')">
            <div>
                 <bitacoraLoginPortalComercial></bitacoraLoginPortalComercial>
            </div>
          </b-tab>
           <b-tab title="GENERACION ARCHIVO DE RENOVACION MANUAL" v-if="$localStorageService.can('Rep_01_descar_archv_sftp_pc')">
             <div>
               <generacionArchivoRenovacion></generacionArchivoRenovacion>
             </div>
           </b-tab>
           <b-tab title="SUBIR ARCHIVO RESPUESTA RENOVACION AUTOMATICA  MANUAL" v-if="$localStorageService.can('Rep_01_subir_archv_sftp_pc')">
             <div>
               <respuestaCargoAutomaticoManual></respuestaCargoAutomaticoManual>
             </div>
           </b-tab>
         </b-tabs>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import Header from "../../components/Header";
import adminTransaccionesPortalComercial from "./adminTransaccionesPortalComercial.vue";
import bitacoraLoginPortalComercial from "./bitacoraLoginPortalComercial.vue";
import generacionArchivoRenovacion from  "./generacionArchivoRenovacion.vue";
import respuestaCargoAutomaticoManual from  "./respuestaCargoAutomaticoManual.vue"
export default {
  name: "adminPortalComercial",
  components: {
    Header,
    adminTransaccionesPortalComercial,
    bitacoraLoginPortalComercial,
    generacionArchivoRenovacion,
    respuestaCargoAutomaticoManual
  },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      datosTabla: [],
      fields: [],
      registrosPorPagina: 10,
      paginaActual: 0,
      loader: false,
      filtro: {
        fechaInicio: new Date(),
        fechaFin: null
      },
      hoy: new Date(),
      diasMaximoMes: null,
      fieldsExcel: {
        "Referencia Multiva": "idReferencia",
        "id Ticket": "idTicket",
        "Fecha Compra":"fechaCompra",
        "Monto Pagado ($)": "montoPagado",
        "Monto menos Comisiones ($)": "montoMenosComisiones",
        "Monto menos iva ($)": "montoMenosIVA",
        "Comision (%)":"comision",
        "Vendedor": "nombreVendedor",
        "Plan":"plan",
        "Titular tarjeta":"titularTarjeta",
        "Id paciente":"idPaciente",
        "Nombre paciente":"nombrePaciente",
        "Tipo asegurado":"tipoAsegurado",
        "Tipo Tarjeta":"tipoTarjeta",
        "Correo":"correo",
        "Msi":"msi",
        "Renovacion":"renovacion",
        "Acepto terminos":"aceptoTermino" 
      },
    };
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  mounted() {
    this.fields = [
      {key: "idReferencia", label: "Referencia Multiva", sortable: true},
      {key: "idTicket", label: "id Ticket", sortable: true},
      {key: "fechaCompra", label: "Fecha Compra", sortable: true},
      {key: "montoPagado", label: "Monto Pagado ($)", sortable: true},
      {key: "montoMenosComisiones", label: "Monto menos Comisiones ($)", sortable: true},
      {key: "montoMenosIVA", label: "Monto menos iva ($)", sortable: true},
      {key: "comision", label: "Comision (%)", sortable: true},
      {key: "plan", label: "Plan", sortable: true},
      {key: "nombreVendedor", label: "Vendedor", sortable: true},
      {key: "titularTarjeta", label: "Titular tarjeta", sortable: true},
      {key: "idPaciente", label: "Id paciente", sortable: true},
      {key: "nombrePaciente", label: "Nombre paciente", sortable: true},
      {key: "tipoAsegurado", label: "Tipo asegurado", sortable: true},
      {key: "tipoTarjeta", label: "Tipo Tarjeta", sortable: true},
      {key: "correo", label: "Correo", sortable: true},
      {key: "msi", label: "Msi", sortable: true},
      {key: "renovacion", label: "Renovacion", sortable: true},
      {key: "aceptoTermino", label: "Acepto terminos", sortable: true}
    ];
  },
  methods:{
      obtenerDatos() {
      let fechaActual = this.$moment(this.filtro.fechaInicio);
      let fechaF = this.$moment(this.filtro.fechaFin);
      let fechaInicial = fechaActual.format("YYYY-MM-DD[T]HH:mm:ssZ");
      let fechaFinal = fechaF.format("YYYY-MM-DD[T]HH:mm:ssZ");
      this.loader = true;
      this.datosTabla = [];
      const filtro = {
          "fechaInicio": fechaInicial,
          "fechaFin": fechaFinal,
          "horas": this.$horas()
        };
        this.$http
            .post(this.$api + 'reportes/renovacionAutomaticaPortal', filtro)
            .then(respuesta => {
              if (respuesta.data.data) {
                if (respuesta.data.data !== undefined) {
                  this.datosTabla = respuesta.data.data;
                }
              }
            }).finally(() => {
          this.loader = false;
          this.paginaActual = 0;
        })
    },
    fechaMaxima(event){
      this.diasMaximoMes = this.$moment(event).daysInMonth();
      this.filtro.fechaInicio = new Date(event);
      this.filtro.fechaFin = null;
      
    },
  }
};
</script>

<style>
</style>
